import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import Map from "../../components/map/Map";
import {DETAIL_ZOOM, initialMapConfig, MapConfig} from "../../components/map/MapConfig";
import UjiBrand from "../../components/ujibrand/UjiBrand";
import Sidebar from "../../components/sidebar/Sidebar";
import Loading from "../../components/loading/Loading";
import {Area} from "../../repositories/area/Area";
import useSidebar from "../../components/sidebar/hooks/UseSidebar.hook";

const HomeScreen: FunctionComponent = () => {
    const {isOpenSidebar, toggleSidebar} = useSidebar();
    const [mapConfig, setMapConfig] = useState<MapConfig>(initialMapConfig);

    const handleToggleSidebar = (): void => {
        toggleSidebar();
    };

    const handleOnAreaSelected = (areaLocation: Area): void => {
        // @ts-ignore
        const newMapConfig: MapConfig = {
            ...mapConfig,
            position: {
                center: {
                    lat: areaLocation.cords.lat,
                    lng: areaLocation.cords.long,
                },
                zoom: DETAIL_ZOOM
            }
        };

        setMapConfig(newMapConfig);
        handleToggleSidebar();
    };

    const handleOnResetView = (): void => {
        setMapConfig(initialMapConfig);
        handleToggleSidebar();
    };

    if (!mapConfig)
        return <Loading loading={true}/>;

    return (
        <Map config={mapConfig}>
            <UjiBrand
                toggleSidebar={handleToggleSidebar}
            />
            <Sidebar
                show={isOpenSidebar}
                toggle={handleToggleSidebar}
                onAreaSelected={handleOnAreaSelected}
                resetView={handleOnResetView}
            />
        </Map>
    );
};

export default HomeScreen;
